/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerHistoryQueryResponse, DocumentDraftsControllerHistoryPathParams, DocumentDraftsControllerHistoryQueryParams, DocumentDraftsControllerHistory400, DocumentDraftsControllerHistory401, DocumentDraftsControllerHistory403, DocumentDraftsControllerHistory404 } from "../../models/documentDraftsController/DocumentDraftsControllerHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentDraftsControllerHistory } from "../../clients/document-draftsService/documentDraftsControllerHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentDraftsControllerHistoryQueryKey = (threadId: DocumentDraftsControllerHistoryPathParams["threadId"], params: DocumentDraftsControllerHistoryQueryParams) => [{
  url: '/api/v1/document-drafts/:threadId',
  params: {
    threadId: threadId
  }
}, ...(params ? [params] : [])] as const;
export type DocumentDraftsControllerHistoryQueryKey = ReturnType<typeof documentDraftsControllerHistoryQueryKey>;
export function documentDraftsControllerHistoryQueryOptions(threadId: DocumentDraftsControllerHistoryPathParams["threadId"], params: DocumentDraftsControllerHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentDraftsControllerHistoryQueryKey(threadId, params);
  return queryOptions<DocumentDraftsControllerHistoryQueryResponse, ResponseErrorConfig<DocumentDraftsControllerHistory400 | DocumentDraftsControllerHistory401 | DocumentDraftsControllerHistory403 | DocumentDraftsControllerHistory404>, DocumentDraftsControllerHistoryQueryResponse, typeof queryKey>({
    enabled: !!(threadId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentDraftsControllerHistory(threadId, params, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts/:threadId}
 */
export function useDocumentDraftsControllerHistory<TData = DocumentDraftsControllerHistoryQueryResponse, TQueryData = DocumentDraftsControllerHistoryQueryResponse, TQueryKey extends QueryKey = DocumentDraftsControllerHistoryQueryKey>(threadId: DocumentDraftsControllerHistoryPathParams["threadId"], params: DocumentDraftsControllerHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentDraftsControllerHistoryQueryResponse, ResponseErrorConfig<DocumentDraftsControllerHistory400 | DocumentDraftsControllerHistory401 | DocumentDraftsControllerHistory403 | DocumentDraftsControllerHistory404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentDraftsControllerHistoryQueryKey(threadId, params);
  const query = useQuery({
    ...documentDraftsControllerHistoryQueryOptions(threadId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentDraftsControllerHistory400 | DocumentDraftsControllerHistory401 | DocumentDraftsControllerHistory403 | DocumentDraftsControllerHistory404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}